import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-197">
      <div className="max-w-4xl mx-auto text-center" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-199">
          <div className="text-5xl mb-4" data-id="element-200">💡</div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-600 mb-2 uppercase tracking-wide" data-id="element-201">
            Por eso creamos
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-8 leading-tight" data-id="element-202">
            🥗 MEGAPACK ALIMENTACIÓN SALUDABLE
          </h3>

          <p className="text-xl md:text-2xl font-medium text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-203">
            Un sistema práctico, simple y realista para que:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto mb-12 text-left" data-id="element-204">
            {['comas rico', 'bajes de peso', 'te organices', 'y sostengas el cambio en el tiempo'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-green-50 p-5 rounded-xl border border-green-200 flex items-center gap-4 shadow-sm" data-id="element-205">
                <div className="bg-green-500 rounded-full p-1 flex-shrink-0" data-id="element-206">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-207">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" data-id="element-208"></path>
                  </svg>
                </div>
                <span className="text-xl font-bold text-gray-800" data-id="element-209">{item}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}